import React from "react";
import {
  TransactionMassage,
  WalletModalStyles,
  ModalWrapper,
  ImgContainer,
  InfoContainer,
  Button,
  ButtonContainer,
} from "./WalletModal.styled";
import factorImg from "assets/images/factor.png";
import priceSeparator from "utils/priceSeparator/PriceSeparator";

export default function WalletModal({ closing, pay, charge }) {
  let taxHandler = (num) => {
    let tax = num * 0.1;
    let taxTotal = +num + +tax;
    return taxTotal;
  };
  return (
    <WalletModalStyles>
      <ModalWrapper>
        <ImgContainer>
          <img src={factorImg} alt="factor" />
        </ImgContainer>
        <TransactionMassage>
          <h2>تایید مبلغ قابل پرداخت</h2>
        </TransactionMassage>
        <InfoContainer>
          <div>
            <div>مبلغ:</div>
            <div>{priceSeparator(charge)} تومان</div>
          </div>
          <div>
            <div>%10 مالیات بر ارزش افزوده:</div>
            <div>{priceSeparator(charge * 0.1)} تومان</div>
          </div>
          <div>
            <div>مبلغ قابل پرداخت:</div>
            <div>{priceSeparator(taxHandler(charge))} تومان</div>
          </div>
        </InfoContainer>
        <ButtonContainer>
          <Button onClick={pay}>پرداخت</Button>
          <Button onClick={closing}>بازگشت</Button>
        </ButtonContainer>
      </ModalWrapper>
    </WalletModalStyles>
  );
}
